import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Clock } from 'lucide-react';
import { blogPosts } from '../mock';

const BlogSection = () => {
  return (
    <section id="blog" className="py-16 md:py-24 bg-[#FFF6EB] scroll-mt-24">
      <div className="max-w-7xl mx-auto px-5">
        <div className="max-w-3xl mb-10">
          <div className="text-xs uppercase tracking-[0.22em] font-bold text-[#FF5C39] mb-3">Smart tips & expert guides</div>
          <h2 className="text-4xl md:text-5xl font-bold text-[#1F0068] tracking-tight leading-tight">
            From saving energy to solving appliance issues
          </h2>
          <p className="mt-4 text-lg text-[#1F0068]/70">You’ll find loads of help and advice here.</p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-5">
          {blogPosts.map((post) => (
            <Link key={post.id} to={`/blog/${post.id}`} className="dhs-card group block rounded-3xl overflow-hidden bg-white border border-[#1F0068]/5">
              <div className="aspect-[16/10] overflow-hidden">
                <img src={post.image} alt={post.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
              </div>
              <div className="p-6">
                <div className="flex items-center gap-3 text-xs text-[#1F0068]/60 mb-3 font-semibold">
                  <span className="inline-flex items-center gap-1 bg-[#FFEDD6] text-[#1F0068] font-bold px-2 py-0.5 rounded-full text-[10px]">{post.category}</span>
                  <span>{post.date}</span>
                  <span className="inline-flex items-center gap-1"><Clock className="w-3 h-3" /> {post.read}</span>
                </div>
                <h3 className="font-bold text-lg text-[#1F0068] leading-snug group-hover:text-[#FF5C39] transition-colors">{post.title}</h3>
                <p className="mt-2 text-sm text-[#1F0068]/70 line-clamp-2">{post.excerpt}</p>
                <div className="mt-4 inline-flex items-center gap-1.5 text-sm font-bold text-[#FF5C39] group-hover:gap-2.5 transition-all">
                  Read more <ArrowRight className="w-4 h-4" />
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BlogSection;
